export default function Badge({ children, variant = "default", className = "", ...props }) {
    const baseStyles =
      "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
  
    const variantStyles = {
      default: "bg-primary text-primary-foreground hover:bg-primary/80",
      outline: "text-foreground border",
    }
  
    const combinedClassName = `${baseStyles} ${variantStyles[variant]} ${className}`
  
    return (
      <div className={combinedClassName} {...props}>
        {children}
      </div>
    )
  }
  
  